import requestV2 from '@/service/request-v2'
import { normalizePageResult } from '@/service/adapters/page-result'
import type { PageQuery, PageResult } from '@/types/crud'

export interface CustomReplyFilters {
  userId: string
  corPid: string | number
  userName: string
  usedBy: string
  nickName: string
  timeSlot?: string[]
  replyStatus: number | string
  unrepliedStatus: number | string
}

export interface CustomReplyRecord {
  id?: string | number
  uname: string
  remark: string
  content: string
  date: string
  corpName: string
  sid: string
  sname: string
  usedBy: string
  deptName: string
  groupName: string
  replyDual: number | null
  replyDualStr: string
}

export interface CustomReplyUsedBy {
  userName: string
}

function buildParams(query: PageQuery<CustomReplyFilters>) {
  return {
    ...query.filters,
    pageNo: query.pageNo,
    pageSize: query.pageSize,
    ...(query.sort
      ? { orderBy: query.sort.prop, orderType: query.sort.order }
      : {})
  }
}

export async function fetchCustomReplyPage(
  query: PageQuery<CustomReplyFilters>,
  signal: AbortSignal
): Promise<PageResult<CustomReplyRecord>> {
  const payload = await requestV2.get<unknown>({
    url: '/main/customReplyV2/queryByCondition',
    params: buildParams(query),
    signal
  })
  return normalizePageResult<CustomReplyRecord>(payload)
}

export async function fetchCustomReplyUsedBy() {
  const payload = await requestV2.get<unknown>({
    url: '/main/enterpriseWechat/dingUser/listAll'
  })
  if (!Array.isArray(payload)) throw new Error('使用人列表响应必须是数组')
  return payload as CustomReplyUsedBy[]
}

export function exportCustomReplyDetail(query: PageQuery<CustomReplyFilters>) {
  return requestV2
    .get<Blob>({
      url: '/main/customReplyV2/download',
      params: buildParams(query),
      responseType: 'blob'
    })
    .then(requireExportFile)
}

export function exportCustomReplySummary(query: PageQuery<CustomReplyFilters>) {
  return requestV2
    .get<Blob>({
      url: '/main/customReply/summary',
      params: buildParams(query),
      responseType: 'blob'
    })
    .then(requireExportFile)
}

async function requireExportFile(blob: Blob) {
  if (!blob.type.includes('application/json')) return blob

  const payload = JSON.parse(await blob.text()) as { message?: string }
  throw new Error(payload.message || '导出失败')
}
